(function () {
  gsap.registerPlugin(ScrollTrigger);

  function initParallax() {
    ScrollTrigger.getAll().forEach((st) => {
      if (st._parallax) st.kill();
    });

    document.querySelectorAll('[data-parallax]').forEach((image) => {
      const imgEl = image.querySelector('img,video');
      if (!imgEl) return;

      const clipPath = image.dataset.parallax !== 'false';

      gsap.set(image, {
        overflow: 'hidden',
        display: 'flex',
        clipPath: clipPath ? 'polygon(2% 2%, 98% 2%, 98% 98%, 2% 98%)' : 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)',
      });

      gsap.set(imgEl, {
        scale: 1.07,
      });

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: image,
          start: window.pageYOffset + image.getBoundingClientRect().top >= 100 ? 'top bottom' : 'top top',
          end: 'bottom top',
          scrub: 0.4,
        },
      });
      tl.scrollTrigger._parallax = true;

      tl.to(imgEl, { scale: 1, ease: 'linear' }, 0);
      tl.to(image, { clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)', ease: 'linear' }, 0);
    });
  }

  initParallax();

  document.addEventListener('page:loaded', () => initParallax());
})();
